import React, { useContext } from "react";

import { LS_DIALER_TEST_CALLS_PER_PAGE } from "const/localStorageKeys";
import { renderColumn } from "utils/helpers";
import { useWindowWidth } from "hooks";
import { servicePick } from "utils";
import CustomizableTable from "components/client/CustomizableTable/CustomizableTable";
import { RtlContext } from "../../App";
import m from "definedMessages";


export default ({
    data = [],
    service,
    loading,
    more,
    page,
    count,
    perPage,
    formatMessage,
    getItems
}) => {
    const windowWidth = useWindowWidth();
    const rtl = useContext(RtlContext);

    const columns = [
        {
            id: "datetime",
            label: formatMessage(m.datetime),
            dataKey: "datetime",
            align: "center",
            flexGrow: 2,
            minWidth: 120,
            value: ({ datetime }) => {
                return (
                    <div className="table-two-staged__cell">
                        <div className="table-two-staged__cell-single">{datetime}</div>
                    </div>
                );
            }
        },
        {
            id: "a_number",
            label: service ? formatMessage(m.aNumber) : formatMessage(m.senderId),
            dataKey: service ? "a_number" : "senderid",
            flexGrow: 2,
            minWidth: 120,
            align: "center",
            value: ({ senderid, a_number, a_subdestination_name }) => {
                return (
                    <>
                        {service
                            ? <div className="table-two-staged__cell">
                                <div className="table-two-staged__cell-first">{a_number}</div>
                                <div className="table-two-staged__cell-second">{a_subdestination_name}</div>
                            </div>
                            : <div className="table-two-staged__cell">
                                <div className="table-two-staged__cell-single">
                                    {senderid}
                                </div>
                            </div>
                        }
                    </>
                );
            }
        },
        {
            id: "b_number",
            label: formatMessage(m.bNumber),
            dataKey: service ? "b_number" : "phone",
            flexGrow: 2,
            minWidth: 120,
            align: "center",
            value: ({ phone, b_number, b_subdestination_name }) => {
                return (
                    <>
                        {service
                            ? <div className="table-two-staged__cell">
                                <div className="table-two-staged__cell-first">{b_number}</div>
                                <div className="table-two-staged__cell-second">{b_subdestination_name}</div>
                            </div>
                            : <div className="table-two-staged__cell">
                                <div className="table-two-staged__cell-single">
                                    {phone}
                                </div>
                            </div>
                        }
                    </>
                );
            }
        },
        {
            id: "range",
            label: formatMessage(m.range),
            dataKey: "range",
            flexGrow: 4,
            minWidth: 200,
            align: "center",
            value: ({ range, range_name }) => {
                return (
                    <div className="table-two-staged__cell">
                        <div className="table-two-staged__cell-single">{servicePick(service, range, range_name)}</div>
                    </div>
                );
            }
        },
        ...(service ? [{
            id: "duration",
            label: formatMessage(m.duration),
            dataKey: "duration",
            flexGrow: 2,
            minWidth: 120,
            align: "center",
            value: ({ duration }) => {
                return (
                    <div className="table-two-staged__cell">
                        <div className="table-two-staged__cell-single">{duration}</div>
                    </div>
                );
            }
        }] : [])
    ];

    const renderedColumns = columns.map(renderColumn);

    return (
        <>
            <CustomizableTable
                {...{
                    rtl,
                    data,
                    count,
                    page,
                    perPage,
                    loading,
                    getItems,
                    renderedColumns
                }}
                data={data}
                isMobile={windowWidth < 768}
                rowHeight={46}
                twoStaged={true}
                isChangedColumns={false}
                isPaginated={true}
                moreCount={more}
                perPageLSKey={LS_DIALER_TEST_CALLS_PER_PAGE}
            />
        </>
    );
}